import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class QuestionChangedWarningModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  render() {
    const { onClose } = this.props;
    return (
      <div>
        <p>
          <FormattedMessage id="modal.exit-diagnostic.text" />
        </p>
        <footer>
          <button onClick={() => onClose(true)}>
            <FormattedMessage id="modal.exit-diagnostic.approve" />
          </button>
          <button onClick={() => onClose(false)}>
            <FormattedMessage id="modal.exit-diagnostic.decline" />
          </button>
        </footer>
      </div>
    );
  }
}

export default QuestionChangedWarningModal;



// WEBPACK FOOTER //
// ./src/modules/modal/exit-diagnostic-modal.js